"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultConditional = void 0;
/**
 * Default conditional function for a widget.
 *
 * This function always returns `true`, indicating that the widget should always be displayed.
 *
 * @param _interview - The interview data (not used in this default implementation).
 * @returns `true` to indicate the widget should be displayed.
 */
const defaultConditional = (_interview) => true;
exports.defaultConditional = defaultConditional;
//# sourceMappingURL=defaultConditional.js.map